import { LANGUAGES_LIST } from "./language.constants"

export const AI_TOOLS_OPTIONS = {
  Improvement: 0,
  Style: 1,
}

export const AI_IMPROVEMENT_OPTIONS = {
  Translate: 2,
  FixSpellGram: 3,
  Summarize: 4,
  Expand: 5,
  Reword: 6,
}

export const AI_STYLE_OPTIONS = {
  Technical: 7,
  Salesy: 8,
  Formal: 9,
  Funny: 10,
  Friendly: 11,
  Proffesional: 12,
}

const CommonContextPrompt = "Do not add sections such as 'Subject:'. Do not lose context of the text such as names, retain formatting and so on. Your response should be only the text you have updated. Text: [text]"

export const DEFINE_LANGUAGE_PROMPT = `Identify the language of the provided text based on its linguistic characteristics. For example, response can be: "English". ${CommonContextPrompt}`;

const AI_IMPROVEMENT_PROMPTS = {
  [AI_IMPROVEMENT_OPTIONS.Translate]: `You are a professional language translator. Translate this text [fromLanguage] to [toLanguage]. Keep the translation as close to the original in tone and style as you can. Fix any spelling and grammar mistakes prior to translation. Do not add symbols such as dot if the text does not contain it. ${CommonContextPrompt}`,
  [AI_IMPROVEMENT_OPTIONS.FixSpellGram]: `You are a native English speaker. Improve this text for spelling mistakes, grammatical errors, punctuation mistakes, sentence clarity and overall readability. ${CommonContextPrompt}`,
  [AI_IMPROVEMENT_OPTIONS.Summarize]: `Summarise this text, ensuring you retain all key points and supporting details and make this text really short. Eliminate extraneous language and focus on critical aspects. Format the output in paragraph form for easy understanding. ${CommonContextPrompt}`,
  [AI_IMPROVEMENT_OPTIONS.Expand]: `Expand this text to be more descriptive and detailed. Do not be overly descriptive, the response should be expanded only enough to provide additional descriptive details to support understanding. ${CommonContextPrompt}`,
  [AI_IMPROVEMENT_OPTIONS.Reword]: `You work for a managed IT services provider. Reword this text to be more clear and concise. ${CommonContextPrompt}`,
}

const AI_STYLE_PROMPTS = {
  [AI_STYLE_OPTIONS.Friendly]: `Prompt: You are a happy, easy going, plain talking professional. Improve this text by making it friendlier tone. Use simple and accessible language. keep sentences short. Do not add explanations, introductions, or meta text. Return only the improved text itself. ${CommonContextPrompt}`,
  [AI_STYLE_OPTIONS.Proffesional]: `Prompt: You work in a professional job and write in a very professional tone. Improve this text by making it more professional in tone. Do not add explanations, introductions, or meta text. Return only the improved text itself. ${CommonContextPrompt}`,
  [AI_STYLE_OPTIONS.Technical]: `You are an IT Engineer and are writing text for another IT Engineer. Improve this text to be more technical. Use acronyms where appropriate. Maintain proper spacing between words and sentences for human readability - do not remove spaces between words or replace them with other characters. Keep the text structure clean and professional. Do not add explanations, introductions, or meta text. Return only the improved text itself. ${CommonContextPrompt}`,
  [AI_STYLE_OPTIONS.Salesy]: `You are a salesman working in technology sales and are writing text for a client who you are trying to sell your services to. Improve this text to be more salesy – it should be convincing, compelling, lead the client to buying your solution to solve their problem, and position your company's product as their best option. It should be professional (not like a car salesman), professional and friendly. Do not add explanations, introductions, or meta text. Return only the improved text itself. ${CommonContextPrompt}`,
  [AI_STYLE_OPTIONS.Formal]: `You are a senior business executive and are writing text for a client in a serious and formal setting. Improve this text to be more formal in tone. Do not add explanations, introductions, or meta text. Return only the improved text itself. ${CommonContextPrompt}`,
  [AI_STYLE_OPTIONS.Funny]: `You are a professional comedian. Improve this text to be funny.  Do not add explanations, introductions, or meta text. Return only the improved text itself. ${CommonContextPrompt}`,
}

export const AI_TRANSLATE_LANGUAGES = LANGUAGES_LIST.map((language) => ({
  key: language,
  label: language,
  value: language,
  prompt: AI_IMPROVEMENT_PROMPTS[AI_IMPROVEMENT_OPTIONS.Translate],
}));

export const AI_IMPROVEMENT_LIST = [
  {
    key: AI_IMPROVEMENT_OPTIONS.FixSpellGram,
    prompt: AI_IMPROVEMENT_PROMPTS[AI_IMPROVEMENT_OPTIONS.FixSpellGram],
    label: 'Fix spelling and grammar',
  },
  {
    key: AI_IMPROVEMENT_OPTIONS.Summarize,
    prompt: AI_IMPROVEMENT_PROMPTS[AI_IMPROVEMENT_OPTIONS.Summarize],
    label: 'Make it shorter',
  },
  {
    key: AI_IMPROVEMENT_OPTIONS.Expand,
    prompt: AI_IMPROVEMENT_PROMPTS[AI_IMPROVEMENT_OPTIONS.Expand],
    label: 'Make it longer',
  },
  {
    key: AI_IMPROVEMENT_OPTIONS.Reword,
    prompt: AI_IMPROVEMENT_PROMPTS[AI_IMPROVEMENT_OPTIONS.Reword],
    label: 'Make it read better',
  },
]

export const AI_STYLE_LIST = [
  {
    key: AI_STYLE_OPTIONS.Friendly,
    prompt: AI_STYLE_PROMPTS[AI_STYLE_OPTIONS.Friendly],
    label: 'Friendly',
  },
  {
    key: AI_STYLE_OPTIONS.Proffesional,
    prompt: AI_STYLE_PROMPTS[AI_STYLE_OPTIONS.Proffesional],
    label: 'Professional'
  },  
  {
    key: AI_STYLE_OPTIONS.Technical,
    prompt: AI_STYLE_PROMPTS[AI_STYLE_OPTIONS.Technical],
    label: 'Technical',
  },
  {
    key: AI_STYLE_OPTIONS.Salesy,
    prompt: AI_STYLE_PROMPTS[AI_STYLE_OPTIONS.Salesy],
    label: 'Salesy',
  },
  {
    key: AI_STYLE_OPTIONS.Formal,
    prompt: AI_STYLE_PROMPTS[AI_STYLE_OPTIONS.Formal],
    label: 'Formal',
  },
  {
    key: AI_STYLE_OPTIONS.Funny,
    prompt: AI_STYLE_PROMPTS[AI_STYLE_OPTIONS.Funny],
    label: 'Funny',
  },
]

export const AI_TOOLS_LIST = [
  {
    key: AI_TOOLS_OPTIONS.Improvement,
    label: 'Improvement',
    options: AI_IMPROVEMENT_LIST,
    wideMenu: true,
  },
  {
    key: AI_TOOLS_OPTIONS.Style,
    label: 'Style',
    options: AI_STYLE_LIST,
  }
]